import { closedComponent } from './closed.component';

export const transferringClosedStateName = 'app.ticket.transferringClosed';

export const transferringClosedState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: transferringClosedStateName,
    url: '/closed',
    component: closedComponent.name,
    data: { requiresAuth: true }
  });
};

export const receivingClosedStateName = 'app.ticket.receivingClosed';

export const receivingClosedState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: receivingClosedStateName,
    url: '/closed',
    component: closedComponent.name,
    data: { requiresAuth: true }
  });
};
